const preferenceGroups = {
  DocumentSearch: {
    menuKey: "Documents",
    preferenceKeys: ["DocumentSearchDefaultAgencyKeys"],
  },

  InventoryThresholds: {
    menuKey: "SalesVolumeAndThresholds",
    preferenceKeys: [
      "DisplayLowInventoryAlertHomePage",
      "NotifyLowInventoryByEmail",
    ],
  },

  BatchSorting: {
    menuKey: "AddBatch",
    preferenceKeys: ["BatchSortColumn", "BatchSortAscending"],
  },
};

export default preferenceGroups;
